export default {
  loading: "拼命加载中",
  totalData: "条数据",
  totalPrefix: "共计",
  download: "下载",
  downloadDetails: "下载数据明细",
  noData: "暂无数据",
  columns: {
    direction: "交易方向",
    currency: "币种",
    quantity: "交易数量",
    price: "单价",
    legalTender: "法币",
    amount: "总金额",
    txTime: "交易时间",
  },
  directions: {
    buy: "买入",
    sell: "卖出",
    unknown: "未知",
  },
};
